export default class InaccessibleEmailError extends Error {
  constructor() {
    super("Inaccessible Email");
  }
}
